import Carousel from 'react-bootstrap/Carousel';
import { Link } from "react-router-dom";
import SliderData from '../menhome/SliderImages.json';
import Marquee from "react-fast-marquee";
import MarqueeData from '../menhome/MarqueeData.json';
import './SliderCSS.css';

function DarkVariantExample() {
    const filterMarqueeData = MarqueeData.filter(item => item.Status ===1);
    const filterSliderData = SliderData.filter(item => item.status ===1);
    return (
        <>
        <Marquee pauseOnHover={true} speed={60}  delay={1} >
                    {filterMarqueeData.map((item, index) => (
                        
                        <a className='me-2'
                            key={index}
                            href={item.link}
                            target="_blank"
                            rel="noopener noreferrer"
                          
                        >
                            <img src="assets/img/icon/new.gif" alt="iconNew" height={16} />
                            {item.desc}   
                            {index !== filterMarqueeData.length - 1 && (
                            <span className='me-2 ms-3'>|</span>)}
                        </a>
                      
                    ))}
                </Marquee>
        <Carousel fade>
            {filterSliderData.map((item, index) => (
                <Carousel.Item key={index} style={{ backgroundImage: `url(${item.image})` }}>
                    <div
                        className="carousel-backdrop"
                        style={{ backgroundImage: `url(${item.image})` }}
                    />
                    <Link to={item.href} >
                        <div
                            className="carousel-foreground"
                            style={{ backgroundImage: `url(${item.image})` }}
                        >     </div>
                    </Link>
                    {item.title || item.subtitle ? ( 
                    <Carousel.Caption style={{ backgroundColor: 'rgba(26,29,30,0.6)', color: 'white', borderRadius: '10px' }}>
                        <h4>{item.title}</h4>
                        <p>{item.subtitle}</p>
                    </Carousel.Caption>
                    ):null}
                </Carousel.Item>
            ))}
        </Carousel>
        </>
    );
}

export default DarkVariantExample;